<template>
    <div class="hiq-public-art__search-info" v-if="query && query !== '*'">
        <h2 class="hiq-public-art__search-info--heading">{{`${translations.resultFor} "${query}" (${total} ${translations.numberOfHits})`}}</h2>        
    </div>
</template>

<script>
export default {
    name: 'search-info',
    computed: {
        query() {
            return this.$store.state.art.query;
        },
        translations() {
            return this.$store.state.translations;
        },
        total() {
            return this.$store.state.art.total;
        }
    }
}
</script>